import { get, post, upload } from '../../utils/api'
import { AxiosResponse } from 'axios'

export const fetchModuleLessonPage = (
  id: string,
  moduleId: string,
  lessonId: string
): Promise<AxiosResponse> =>
  get(`/courses/courses/${id}/modules/${moduleId}/lessons/${lessonId}`, {
    include: [
      'userLesson',
      'blocks',
      'blocks.gallery',
      'blocks.files',
      'blocks.links',
      'blocks.videos',
      'blocks.notion',
      'blocks.simpleTask',
      'blocks.simpleTask.task.userSimpleTask',
    ].join(','),
  })

export const fetchCourseUserState = (id: string): Promise<AxiosResponse> =>
  get(`/courses/courses/${id}/user-state`)

export const fetchSimpleTaskStatus = (
  id: string,
  mid: string,
  lid: string,
  task_id: string
): Promise<AxiosResponse> =>
  get(
    `/courses/courses/${id}/modules/${mid}/lessons/${lid}/simple-tasks/${task_id}`
  )

export const joinSimpleTask = (
  id: string,
  mid: string,
  lid: string,
  task_id: string
): Promise<AxiosResponse> =>
  post(
    `/courses/courses/${id}/modules/${mid}/lessons/${lid}/simple-tasks/${task_id}/join`
  )

export const sendSimpleTask = (
  id: string,
  mid: string,
  lid: string,
  simpleTaskId: string,
  field_value?: string,
  file?: File
): Promise<AxiosResponse> =>
  file
    ? upload(
        `/courses/courses/${id}/modules/${mid}/lessons/${lid}/simple-tasks/${simpleTaskId}/complete`,
        {
          field: 'file',
          item: file,
        },
        {
          field_value,
        }
      )
    : post(
        `/courses/courses/${id}/modules/${mid}/lessons/${lid}/simple-tasks/${simpleTaskId}/complete`,
        {
          field_value,
        }
      )

export const setLessonComplete = (
  id: string,
  moduleId: string,
  lessonId: string
): Promise<AxiosResponse> =>
  post(
    `/courses/courses/${id}/modules/${moduleId}/lessons/${lessonId}/complete`
  )

export const fetchModule = (
  id: string,
  moduleId: string
): Promise<AxiosResponse> =>
  get(`/courses/courses/${id}/modules/${moduleId}`, {
    include: 'lessons,lessons.userLesson,moduleScreens,userModule',
  })
